import modelEnhance from '@/utils/modelEnhance';

import { detail, bad_list, custom_list } from '../service';

export default modelEnhance({
    namespace: 'badjs_list',
    state: {
        badHost: {},
        badList: {
            list: [
                {
                    _id: 1,
                    msg: '"ddd" is not defined',
                    count: 100003,
                    percent: 34.12,
                    time: new Date()
                },
                {
                    _id: 2,
                    msg: '"ddd" is not defined',
                    count: 100003,
                    percent: 34.12,
                    time: new Date()
                }
            ]
        },
        customList: {
            list: []
        }
    },
    subscriptions: {
        setup({ dispatch, history }) {
            return history.listen(({ pathname, query }) => {
                if (pathname.indexOf('/badjs/list') > -1) {

                    // dispatch({
                    //     type: 'getDetail', payload: {
                    //         host_id: pathname.split('/')[3]
                    //     }
                    // });
                }
            });
        }
    },
    effects: {
        *getDetail({ payload }, { call, put }) {
            try {
                const { code, msg, data } = yield call(detail, payload);

                if (code) return false;

                yield put({
                    type: 'setDetail',
                    payload: data
                });

                return data;

            } catch (e) {
                console.log(e);
            }
        },
        *getBadList({ payload }, { call, put }) {
            try {
                const { code, msg, data } = yield call(bad_list, payload);

                if (code) return false;

                yield put({
                    type: 'setBadList',
                    payload: data
                });

            } catch (e) {
                console.log(e);
            }
        },
        *getCustomList({ payload }, { call, put }) {
            try {
                const { code, msg, data } = yield call(custom_list, payload);

                if (code) return false;

                yield put({
                    type: 'setCustomList',
                    payload: data
                });

            } catch (e) {
                console.log(e);
            }
        },
        *searchUrl({ payload }, { call, put }) {
            try {
                const { code, msg, data } = yield call(search, payload);

                if (code) return false;

                yield put({
                    type: 'setList',
                    payload: data
                });

            } catch (e) {
                console.log(e);
            }
        }
    },
    reducers: {
        setDetail(state, { payload }) {
            return {
                ...state,
                badHost: { ...payload.item }
            };
        },
        setBadList(state, { payload }) {
            return {
                ...state,
                badList: { ...payload }
            };
        },
        setCustomList(state, { payload }) {
            return {
                ...state,
                customList: { ...payload }
            };
        },
        modifyPage(state, { payload }) {

            let list = state.pageList.list;

            list = list.map((item) => {

                if (item._id == payload._id) {

                    return {
                        ...item,
                        ...payload
                    }
                }
                return item;
            });

            return {
                ...state,
                pageList: {
                    list: [...list]
                }
            };
        }
    }
});